import type { Unwrapped } from '@/api/envelope';

export type ValorDadoRelatorio = string | number | boolean | null;
export type DadosRelatorioItem = Record<string, ValorDadoRelatorio>;

export interface RelatorioApi {
  ID: number;
  Numeracao_Relatorio: string;
  Nome_Relatorio: string;
  EntradaSaida: string;
  IND_OPER: string;
  Tipo: string;
  Doc: string;
  Descricao_Regra: string;
  Status: string;
}

export type ListarRelatoriosResponse = RelatorioApi[];

export interface ListarRelatoriosFiltros {
  tipoRelatorio?: string;
  entradaSaida?: string;
  tipoDocumento?: string;
  cnpjContribuinte?: string;
}

export interface AgendamentoApi {
  id: number;
  CNPJ_Contribuinte: string;
  DataHora_Agendamento: string;
  DataHoraInicio_Processamento: string;
  DataHoraFim_Processamento: string;
  Agendamento_tipo: string;
  Agendamento_Status: string;
  Caminho_Relatorio: string | null;
  Caminho_Relatorio_CSV: string | null;
  Nome_Relatorio?: string;
}

export type ListarAgendamentosResponse = AgendamentoApi[];
export type ListarAgendamentosPeriodoResponse = AgendamentoApi[];

export interface ListarAgendamentosFiltros {
  relatorioId: number;
  cnpjContribuinte?: string;
}

export interface ListarAgendamentosPeriodoFiltros {
  cnpjContribuinte: string;
  data: string;
}

export interface ParametroRelatorioApi {
  id: number;
  Relatorio_id: number;
  nome: string;
  descricao: string;
  tipo: string;
  tamanho: number;
  valor_padrao: string;
  obrigatorio: boolean;
  visivel: boolean;
  Status: string;
}

export type ListarParametrosResponse = ParametroRelatorioApi[];

export interface TipoAgendamentoApi {
  id: number;
  Descricao: string;
  Quantidade_Adicao_Dias: number;
}

export type BuscarTiposAgendamentosResponse = TipoAgendamentoApi[];

export interface ParametroAgendamentoPayload {
  parametro_nome: string;
  parametro_valor: string;
}

export interface GravarAgendamentoPayload {
  agendamento_tipo_id: string;
  relatorio_id: number;
  parametros: ParametroAgendamentoPayload[];
}

export interface GerarRelatorioPayload {
  agendamento_id: number;
}

export interface SolicitacaoEnfileiradaApi {
  solicitacao_id: number;
}

export type GerarRelatorioPDFResponse = SolicitacaoEnfileiradaApi;
export type GerarRelatorioCSVResponse = SolicitacaoEnfileiradaApi;

export interface GerarRelatorioPDFLotePayload {
  agendamento_ids: number[];
}

export type GerarRelatorioPDFLoteResponse = SolicitacaoEnfileiradaApi;

export const SOLICITACAO_STATUS_DISPONIVEL = 1;
export const SOLICITACAO_STATUS_FALHOU = 2;
export const SOLICITACAO_STATUS_PENDENTE = 3;
export const SOLICITACAO_STATUS_PROCESSANDO = 4;

export interface StatusSolicitacaoApi {
  ID: number;
  Status_id: number;
  Caminho_Relatorio: string | null;
  Mensagem_Erro: string | null;
  Tipo: string;
  DataHoraCriacao: string;
  DataHoraConclusao: string | null;
}

export type BuscarStatusSolicitacaoResponse = StatusSolicitacaoApi;

export interface HistoricoSolicitacaoApi {
  ID: number;
  CNPJ_Gestor: string;
  DataHoraCriacao: string;
  Caminho_Relatorio: string;
  Tipo: string;
  UsuarioSolicitacao: string;
  Status_id: number;
  Mensagem_Erro: string | null;
}

export type ListaHistoricoSolicitacoesResponse = Unwrapped<HistoricoSolicitacaoApi[]>;

export type ListarDadosResponse = DadosRelatorioItem[];

export interface ListarDadosFiltros {
  agendamentoId: number;
}

export interface ItemExcluidoApi {
  CaixaEntrada: string;
  Ano: string;
  Mes: string;
  ESC_NUM_DOC: string;
  ESC_IND_OPER: string;
  ESC_SER: string;
  ESC_NUM_ITEM: string;
  ESC_COD_ITEM: string;
  ESC_CHV: string;
  ESC_COD_MOD: string;
  ESC_COD_PART: string;
  Descricao_Regra: string;
}

export type ListarItensExcluidosResponse = ItemExcluidoApi[];

export interface ListarItensExcluidosFiltros {
  agendamentoId: string;
}

export interface CampoApi {
  Campo_id: number;
  Nome_Campo: string;
  Descricao_Campo: string;
  Descricao_Simplificada_Campo: string;
  Tipo: string;
  Sequencia_Separacao: number | null;
  Ordenacao: number | null;
  Configurado: 'S' | 'N';
  Sequencia_Campo: number;
  Totalizador: 'S' | 'N';
  CondicaoTotalizador: 'S' | 'N';
}

export type ListarCamposResponse = CampoApi[];

export interface CampoPayload {
  Campo_id: string;
  Sequencia_Separacao: string;
  Ordenacao: string;
  Configurado: boolean;
  Totalizador: boolean;
  CondicaoTotalizador: boolean;
}

export interface GravarCamposPayload {
  relatorioId: string;
  campos: CampoPayload[];
}

export interface AtualizaConfigRelatorioPayload {
  relatorio_id: number;
  Descricao_Regra: string;
}

export interface DeletarAgendamentoPayload {
  agendamento_id: string;
}
